import React from "react";
import { BrandLogo } from "./BrandLogo";

/**
 * Full-screen branded loader for pre-shell states — the auth gate and route
 * lazy-load fallbacks — replacing the bare/unstyled `<div>Loading...</div>`
 * (review v2 §2). Matches the NotFoundPage / ScreenSizeCheck visual language.
 */
export function FullScreenLoader() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
      <BrandLogo className="h-6 opacity-90" alt="Composo" />
      <div
        className="h-5 w-5 animate-spin rounded-full border-2 border-muted border-t-primary"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
